export default __webpack_public_path__ + "static/section_5-025223f31285a5540d6d3eb98b690ad6.png";